import { render, staticRenderFns } from "./EvaluacionProductividadDialogComponent.vue?vue&type=template&id=37af0079&scoped=true"
import script from "./EvaluacionProductividadDialogComponent.vue?vue&type=script&lang=js"
export * from "./EvaluacionProductividadDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./EvaluacionProductividadDialogComponent.vue?vue&type=style&index=0&id=37af0079&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37af0079",
  null
  
)

export default component.exports